var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 20C10.8907 20 9.85132 19.7914 8.88149 19.3741C7.91167 18.9567 7.06428 18.3856 6.33931 17.6606C5.61435 16.9356 5.04322 16.0881 4.62592 15.1183C4.20864 14.1484 4 13.109 4 12C4 10.891 4.20864 9.85159 4.62592 8.88172C5.04322 7.91186 5.61435 7.06443 6.33931 6.33943C7.06428 5.61443 7.91167 5.04327 8.88149 4.62595C9.85132 4.20865 10.8907 4 11.9996 4C13.1483 4 14.2421 4.23717 15.2812 4.71152C16.3203 5.18589 17.2263 5.84743 17.9993 6.69615V4.3077H18.9993V8.46155H14.8456V7.46155H17.3263C16.6302 6.69488 15.827 6.09296 14.9168 5.65578C14.0066 5.21859 13.0342 5 11.9996 5C10.0497 5 8.39562 5.67917 7.03735 7.0375C5.67909 8.39583 4.99995 10.05 4.99995 12C4.99995 13.95 5.67909 15.6042 7.03735 16.9625C8.39562 18.3208 10.0497 19 11.9996 19C13.7495 19 15.2722 18.4301 16.5677 17.2904C17.8631 16.1506 18.6467 14.7205 18.9185 13H19.93C19.6928 15.0141 18.8195 16.6843 17.31 18.0106C15.8004 19.3369 14.0303 20 11.9996 20Z",
    fill: "#282828"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollIcon);
export default __webpack_public_path__ + "static/media/enroll-icon.9e5b37684cb1bdbf233eb468f643a644.svg";
export { ForwardRef as ReactComponent };